import React from 'react';
import PropTypes from 'prop-types';

function getLinkTarget(openLinkInNewTab) {
    return openLinkInNewTab ? '_blank' : '';
}

export default function TextOrLinkTitle({
    navigationLink,
    openLinkInNewTab,
    title
}) {
    if (!navigationLink) {
        return <span>{title}</span>;
    }

    const target = getLinkTarget(openLinkInNewTab);

    return (
        <a href={navigationLink} target={target}>
            {title}
        </a>
    );
}

TextOrLinkTitle.propTypes = {
    navigationLink: PropTypes.string,
    openLinkInNewTab: PropTypes.bool,
    title: PropTypes.string.isRequired
};

TextOrLinkTitle.defaultProps = {
    navigationLink: undefined,
    openLinkInNewTab: true
};
